import { render, staticRenderFns } from "./VeJwJingsaiProjectStatisticsModal.vue?vue&type=template&id=bc1c0f4e"
import script from "./VeJwJingsaiProjectStatisticsModal.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiProjectStatisticsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports